<template>
  <div class="bg-white rounded-lg border border-gray-200 mb-0 ml-0 px-4 py-2 mr-0 relative group cursor-pointer" :title="formatTokenUsage()">
    <div class="flex justify-between items-center mb-2">
      <span class="text-sm text-gray-600 font-medium">Token Limit</span>
      <span class="text-sm text-gray-600">{{ tokenUsage.percentage }}%</span>
    </div>
    <div class="h-2 bg-gray-100 rounded-full overflow-hidden">
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="{
          'bg-red-500': tokenUsage.percentage >= 80,
          'bg-yellow-500': tokenUsage.percentage >= 60 && tokenUsage.percentage < 80,
          'bg-blue-500': tokenUsage.percentage < 60
        }"
        :style="{ width: `${tokenUsage.percentage}%` }"
      ></div>
    </div>
    
    <!-- Hover Tooltip -->
    <div class="absolute top-1/2 left-full transform -translate-y-1/2 ml-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap z-20">
      {{ formatTokenUsage() }}
      <div class="absolute left-0 top-1/2 transform -translate-y-1/2 -ml-1 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-800"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenUsage',
  props: {
    tokenUsage: {
      type: Object,
      required: true,
      validator: (value) => {
        console.log('[TokenUsage Validator] 전달된 값:', value);
        
        // null이나 undefined 체크
        if (!value || typeof value !== 'object') {
          console.error('[TokenUsage Validator] 값이 객체가 아닙니다:', value);
          return false;
        }
        
        // percentage 속성 체크
        if (typeof value.percentage !== 'number') {
          console.error('[TokenUsage Validator] percentage가 숫자가 아닙니다:', value.percentage);
          return false;
        }
        
        // percentage 범위 체크
        if (value.percentage < 0 || value.percentage > 100) {
          console.error('[TokenUsage Validator] percentage가 범위를 벗어났습니다:', value.percentage);
          return false;
        }
        
        console.log('[TokenUsage Validator] 검증 통과:', value);
        return true;
      }
    }
  },
  methods: {
    formatTokenUsage() {
      const used = this.tokenUsage.used || 0;
      const total = this.tokenUsage.total || 0;
      return `${used.toLocaleString()} / ${total.toLocaleString()}`;
    }
  }
}
</script> 